import React from 'react';
import useBuildNavigationItems from './useBuildNavigationItems';
import {useGuestGroup} from 'hooks';
import {useSummary} from 'context/summary';
import {useTranslation} from 'react-i18next';
import {NavigationStatus} from 'components/NavigationAlert/NavigationAlert';
import NavigationAlert from 'components/NavigationAlert';
import NavigationItem, {PaymentsNavigationItem} from 'components/NavigationItem';

function NavigationPanel() {
  const {data, isGuestappComplete, arePaymentsAvailable} = useSummary();
  const {guestGroup} = useGuestGroup();
  const {t} = useTranslation();
  const hasRegisterGuest = Boolean(guestGroup?.added_number_of_guests);

  const {displayedNavigationItems} = useBuildNavigationItems({data});

  const alertStatus = isGuestappComplete
    ? NavigationStatus.success
    : NavigationStatus.warning;

  return (
    <>
      {hasRegisterGuest && <NavigationAlert status={alertStatus} />}
      {displayedNavigationItems.map((navItem, index) => {
        return (
          <NavigationItem
            title={t(navItem.title)}
            completed={navItem.completed}
            key={index}
            path={navItem.path}
            icon={navItem.icon}
            statusText={navItem.statusText}
          />
        );
      })}
      {arePaymentsAvailable && <PaymentsNavigationItem />}
    </>
  );
}

export {NavigationPanel};
